export const ErrorCode = {
  BookingCutoffTime: 'BOOKING_CUTOFF_TIME',
  BookingsNotAccepted: 'BOOKINGS_NOT_ACCEPTED',
  BookingTimeConflict: 'BOOKING_TIME_CONFLICT',
  CourseArchived: 'COURSE_ARCHIVED',
  DuplicateEmail: 'DUPLICATE_EMAIL',
  DuplicateVanityName: 'DUPLICATE_VANITY_NAME',
  ExceedsMaxPayment: 'EXCEEDS_MAX_PAYMENT',
  ExceedsRoomCapacity: 'EXCEEDS_ROOM_CAPACITY',
  ExistingCustomer: 'EXISTING_CUSTOMER',
  IncorrectPassword: 'INCORRECT_PASSWORD',
  InvalidAuthIntent: 'INVALID_AUTH_INTENT',
  InvalidOTP: 'INVALID_OTP',
  LessonBooked: 'LESSON_BOOKED',
  LessonPricing: 'LESSON_PRICING',
  LessonScheduleWindow: 'LESSON_SCHEDULE_WINDOW',
  LessonAvailability: 'LESSON_AVAILABILITY',
  LessonCapacityBelowBookings: 'LESSON_CAPACITY_BELOW_BOOKINGS',
  LessonTimeConflict: 'LESSON_TIME_CONFLICT',
  OrgAbilityUnavailable: 'ORG_ABILITY_UNAVAILABLE',
  OrgInviteBlacklist: 'ORG_INVITE_BLACKLIST',
  OrgNotRegistered: 'ORG_NOT_REGISTERED',
  PaginationCursorError: 'PAGINATION_CURSOR_ERROR',
  PaymentFailed: 'PAYMENT_FAILED',
  PaymentMethodExpiry: 'PAYMENT_METHOD_EXPIRY',
  RefundExceedPayment: 'REFUND_EXCEED_PAYMENT',
  ResendEmailRateLimit: 'RESEND_EMAIL_RATE_LIMIT',
  ReviewNotAllowed: 'REVIEW_NOT_ALLOWED',
  StaffUserAccountRequired: 'STAFF_USER_ACCOUNT_REQUIRED',
  VanityNameChangeCooldown: 'VANITY_NAME_CHANGE_COOLDOWN',
  VenueLimit: 'VENUE_LIMIT',
  VenueRoomLimit: 'VENUE_ROOM_LIMIT'
} as const;

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];
